import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { EnvironmentService } from './environment.service';


@Injectable()
export class AppLoadService {
    isProdIn:boolean;
    isEtisalat:boolean;
    constructor(
        private authService: AuthService,
        private configService: ConfigService,
        private sessionService: SessionService,
        private environmentService: EnvironmentService
        
    ) { }

    public returnPromise = () => {

        return new Promise((resolve, reject) => {
            return resolve(null);
            // if (this.isPublicPage()) return resolve();

            // this.authService.login();
            // return;
        })
    }

    initAuthStatus(): Observable<any> {
        return Observable.of();
    }

    getQeueryParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    isPublicPage() {
        let publicRoutes = [
            '/login',
            '/logout',
            '/legal',
            '/welcome',
            '/support',
            '/register',
            '/public',
            '/unsubscribe-user',
            '/buyer/seller-signup',
            '/set-new-password',
            '/login/callback'
        ];
        let result = false;
        publicRoutes.forEach(_ => {
            if (window.location.pathname.startsWith(_)) {
                result = true;
                return;
            };
        });

        return result;
    }
    initializeDomainConfig(): Promise<any> {
        this.isProdIn = this.environmentService.isProdIn;
        this.isEtisalat = this.environmentService.isEtisalat;
        // cannot use angular router because router module is not initialised yet
        const isRegister = window.location.href.includes('/register') || window.location.href.includes('/support');
        
        let userGroup: any = this.sessionService.getUserDetails();
        userGroup = userGroup && userGroup['groups'] || [];
        const isSeller = userGroup.indexOf('seller') > -1 || userGroup.indexOf('seller-admin') > -1;
        if ((this.isProdIn || this.isEtisalat) &&
            (isRegister || isSeller)
        ) {
            const apiUrl = this.configService.get('server').apiUrl;
            let domainUrl = `${apiUrl}/domain/details/${this.isEtisalat ? 'etisalat':'fsp'}`;
            return this.authService.getDomainData(domainUrl).toPromise().then(response => {
                let urlBucket = this.configService.get('aws').downloadUrl + '/' + environment.config.aws.cdnBucket;
                response.data.logo.header.url = urlBucket + response.data.logo.header.url;
                response.data.logo.light.url = urlBucket + response.data.logo.light.url;
                response.data.logo.dark.url = urlBucket + response.data.logo.dark.url;
                this.configService.setDomainConfigData(response.data);
            });
        } else {
            return;
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/core/services/app-load.service.ts